import React, { useState } from 'react';
import { Nav } from './Nav';
import { API_BASE_URL } from '../utils/apiBaseUrl';
import { useContext } from 'react';
import { GlobalContext } from '../context/GlobalState';
import { Link, useNavigate } from 'react-router-dom';

export const RegistrationForm = () => {
  const { showNotification, handleLoggedIn } = useContext(GlobalContext);
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);

  const handleSubmit = async event => {
    event.preventDefault();

    setMessage('');
    setIsError(false);

    const userData = {
      password: password,
      email: email,
    };
    // Make a POST request to the server to save the user data
    if (
      email.length > 0 &&
      password.length > 0 &&
      password === confirmPassword
    ) {
      try {
        setIsSubmitting(true);

        const response = await fetch(`${API_BASE_URL}/users/register`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(userData),
        });

        const data = await response.json();

        if (!response.ok) {
          const serverMessage = data?.message || 'Registration failed.';
          setMessage(serverMessage);
          setIsError(true);
          showNotification(serverMessage, 'warning');
          return;
        }

        let userId = data?.userId;
        let userEmail = data?.email;

        // Backward-compatible fallback for register responses without user identity.
        if (!userId || !userEmail) {
          const loginResponse = await fetch(`${API_BASE_URL}/users/login`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(userData),
          });

          const loginData = await loginResponse.json();

          if (!loginResponse.ok || !loginData?.userId) {
            const loginError =
              loginData?.message ||
              'Account created, but auto sign-in failed. Please sign in.';
            setMessage(loginError);
            setIsError(true);
            showNotification(loginError, 'warning');
            return;
          }

          userId = loginData.userId;
          userEmail = loginData.email;
        }

        setMessage('Account created. Redirecting...');
        setIsError(false);
        handleLoggedIn(userId, userEmail);
        showNotification('Account created successfully.', 'success');
        navigate('/user/home/bands', { replace: true });
      } catch (error) {
        const errorMessage = 'Registration failed. Please try again.';
        setMessage(errorMessage);
        setIsError(true);
        showNotification(errorMessage, 'error');
        console.error('Error registering user:', error);
      } finally {
        setIsSubmitting(false);
      }
    } else {
      setMessage('Please enter a valid email and matching passwords.');
      setIsError(true);
      showNotification(
        'Please enter a valid email and matching passwords.',
        'warning',
      );
    }
  };

  return (
    <div className='registration'>
      <Nav />
      <form onSubmit={handleSubmit}>
        <div className='form-item'>
          <label htmlFor='email'>Email:</label>
          <input
            type='email'
            id='email'
            value={email}
            onChange={event => setEmail(event.target.value)}
          />
        </div>
        <div className='form-item'>
          <label htmlFor='password'>Password:</label>
          <input
            type='password'
            id='password'
            value={password}
            onChange={event => setPassword(event.target.value)}
          />
        </div>
        <div className='form-item'>
          <label htmlFor='confirm-password'>Confirm Password:</label>
          <input
            type='password'
            id='confirm-password'
            value={confirmPassword}
            onChange={event => setConfirmPassword(event.target.value)}
          />
        </div>
        <button type='submit' disabled={isSubmitting}>
          {isSubmitting ? 'Creating account...' : 'Create Account'}
        </button>
        <p className='auth-switch'>
          Already have an account? <Link to='/login'>Sign In</Link>
        </p>
      </form>
      {message && (
        <div className={isError ? 'message-error' : 'message-success'}>
          {message}
        </div>
      )}
    </div>
  );
};
